"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var material_1 = require("@mui/material");
var approvals_helper_1 = require("../approvals_helper");
var details_field_1 = require("./details_field");
var button_component_1 = require("../../../../../common/buttons/button_component");
var edit_button_component_1 = require("../../../../../common/buttons/edit_button_component");
var appConstants_1 = require("../../../../../constants/appConstants");
var lodash_1 = require("../../../../../utils/lodash");
var react_router_1 = require("react-router");
var array_helpers_1 = require("../../../../../utils/array_helpers");
var menu_constants_1 = require("../../../../../menuList/menu_constants");
var react_hot_toast_1 = require("react-hot-toast");
var BillingDetailsApprovalView = function (_a) {
    var _b, _c;
    var previousData = _a.previousData, updatedData = _a.updatedData, isUpdatedData = _a.isUpdatedData, setIsUpdated = _a.setIsUpdated, isUpdated = _a.isUpdated;
    var features = (0, array_helpers_1.getAccessibleFeatures)(menu_constants_1.FEATURE_CONSTANTS.approvals);
    var id = (0, react_router_1.useParams)().id;
    var pathName = window.location.pathname;
    var levelOneDetails = pathName.includes('level1-details');
    var _d = React.useState(false), isSectionEdit = _d[0], setIsSectionEdit = _d[1];
    var _e = React.useState({}), temporaryData = _e[0], setTemporaryData = _e[1];
    var textFieldOnchangeHandler = function (value, key) {
        setTemporaryData(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = value, _a)));
        });
    };
    var dropdownOnchangeHandler = function (value, key, lableName) {
        if (lableName === 'Billing Module') {
            if (value.label === 'No Billing') {
                setTemporaryData(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), (_a = {}, _a['billing_type'] = '--', _a['billing_cost'] = '--', _a)));
                });
            }
            else {
                setTemporaryData(function (prev) {
                    var _a;
                    var next = __assign(__assign({}, prev), (_a = {}, _a['billing_type'] = appConstants_1.BILLING_COST_RULES[value.label], _a));
                    delete next['billing_cost'];
                    return next;
                });
            }
        }
        setTemporaryData(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = value, _a)));
        });
    };
    var submitHandler = function () {
        var _a, _b;
        if (Object.keys(temporaryData).length === 0) {
            react_hot_toast_1.default.error('No changes made', { duration: 3000 });
            return;
        }
        var baseData = isUpdatedData ? updatedData : previousData;
        var effectiveModule = (_a = temporaryData['billing_module']) !== null && _a !== void 0 ? _a : baseData === null || baseData === void 0 ? void 0 : baseData.billing_module;
        var moduleLabel = typeof effectiveModule === 'object'
            ? effectiveModule === null || effectiveModule === void 0 ? void 0 : effectiveModule.label
            : effectiveModule;
        if (!effectiveModule) {
            react_hot_toast_1.default.error('Billing module should be mandatory', { duration: 3000 });
            return;
        }
        if (moduleLabel !== 'No Billing') {
            var effectiveCost = (_b = temporaryData['billing_cost']) !== null && _b !== void 0 ? _b : baseData === null || baseData === void 0 ? void 0 : baseData.billing_cost;
            if (!effectiveCost || effectiveCost === '--') {
                react_hot_toast_1.default.error('Billing cost should be mandatory', { duration: 3000 });
                return;
            }
        }
        var copy = lodash_1.default.cloneDeep(temporaryData);
        Object.keys(copy).forEach(function (key) {
            if (copy[key] && typeof copy[key] === "object" && 'label' in copy[key]) {
                copy[key] = copy[key].label;
            }
        });
        (0, approvals_helper_1.updateFeDetails)({ billing_details: copy, is_approval_flow: 1 }, id)
            .then(function (res) {
            if (res.data.statusCode === 200) {
                setIsSectionEdit(!isSectionEdit);
                setIsUpdated(!isUpdated);
                setTemporaryData({});
            }
        })
            .catch(function () {
            react_hot_toast_1.default.error('Something went wrong', { duration: 3000 });
        });
    };
    var getModuleLabel = function (module) {
        return typeof module === 'object' ? module === null || module === void 0 ? void 0 : module.label : module;
    };
    var isUpdatedColumnNoBilling = getModuleLabel((_b = temporaryData['billing_module']) !== null && _b !== void 0 ? _b : updatedData === null || updatedData === void 0 ? void 0 : updatedData.billing_module) === 'No Billing';
    var isPreviousColumnNoBilling = getModuleLabel(isUpdatedData
        ? previousData === null || previousData === void 0 ? void 0 : previousData.billing_module
        : ((_c = temporaryData['billing_module']) !== null && _c !== void 0 ? _c : previousData === null || previousData === void 0 ? void 0 : previousData.billing_module)) === 'No Billing';
    return (React.createElement("div", { className: "visit-details" },
        features[menu_constants_1.FEATURE_CONSTANTS.FELevelOneEdit] && levelOneDetails &&
            React.createElement(material_1.Grid, { display: 'flex', justifyContent: 'end', sx: { margin: '0px 0px 10px' } }, !isSectionEdit ?
                React.createElement(edit_button_component_1.default, { buttonName: "Edit", onClickHandler: function () { return setIsSectionEdit(!isSectionEdit); } })
                :
                    React.createElement(material_1.Box, { sx: { display: 'flex', gap: '10px' } },
                        React.createElement(button_component_1.default, { buttonName: "Cancel", color: "yellow-outline", onClickHandler: function () {
                                setIsSectionEdit(!isSectionEdit);
                                setTemporaryData({});
                            } }),
                        React.createElement(button_component_1.default, { buttonName: "Submit", color: "yellow", onClickHandler: submitHandler }))),
        React.createElement(material_1.Grid, { container: true, spacing: 2, columns: 12, className: "details-profile-grid" },
            React.createElement(material_1.Grid, { item: true, xs: isUpdatedData
                    ? 6
                    : 12, container: true },
                isUpdatedData && (React.createElement(material_1.Grid, { className: "tab-heading-wrapper", item: true, xs: 12 },
                    React.createElement("div", { className: "tab-heaidng profile-detail-heaidng" },
                        React.createElement("h2", null, "Previous Data")))),
                React.createElement(material_1.Grid, { item: true, xs: 12, container: true, className: "mini-details-wrapper" }, previousData &&
                    Object.entries(approvals_helper_1.approvalsFormConstants.billing_details)
                        .filter(function (_a) {
                        var key = _a[0];
                        return key in previousData &&
                            !(key === 'billing_cost' && isPreviousColumnNoBilling);
                    })
                        .map(function (_a) {
                        var _b;
                        var key = _a[0], value = _a[1];
                        return (React.createElement(details_field_1.default, { key: key, fieldKey: key, lableName: value.label, value: isUpdatedData ? previousData[key] : (_b = temporaryData === null || temporaryData === void 0 ? void 0 : temporaryData[key]) !== null && _b !== void 0 ? _b : previousData[key], isEditable: isUpdatedData ? false : value.editable, fieldType: value.type, isSectionEdit: isUpdatedData ? false : isSectionEdit, textFieldOnchangeHandler: textFieldOnchangeHandler, dropdownOnchangeHandler: dropdownOnchangeHandler, showEmpty: true }));
                    }))),
            updatedData &&
                isUpdatedData && (React.createElement(material_1.Grid, { item: true, xs: 6, container: true },
                React.createElement(material_1.Grid, { className: "tab-heading-wrapper", item: true, xs: 12 },
                    React.createElement("div", { className: "tab-heaidng profile-detail-heaidng" },
                        React.createElement("h2", null, "Updated Data"))),
                React.createElement(material_1.Grid, { item: true, xs: 12, container: true, className: "mini-details-wrapper" }, updatedData &&
                    Object.entries(approvals_helper_1.approvalsFormConstants.billing_details)
                        .filter(function (_a) {
                        var key = _a[0], value = _a[1];
                        return (key in updatedData || (value.editable && isSectionEdit)) &&
                            !(key === 'billing_cost' && isUpdatedColumnNoBilling);
                    })
                        .map(function (_a) {
                        var _b, _c;
                        var key = _a[0], value = _a[1];
                        return (React.createElement(details_field_1.default, { key: key, fieldKey: key, lableName: value.label, value: (_c = (_b = temporaryData === null || temporaryData === void 0 ? void 0 : temporaryData[key]) !== null && _b !== void 0 ? _b : updatedData[key]) !== null && _c !== void 0 ? _c : '--', isEditable: isUpdatedData
                                ? value.editable
                                : false, fieldType: value.type, isSectionEdit: isUpdatedData ? isSectionEdit : false, textFieldOnchangeHandler: textFieldOnchangeHandler, dropdownOnchangeHandler: dropdownOnchangeHandler, showEmpty: false }));
                    })))))));
};
exports.default = BillingDetailsApprovalView;
